import { AxiosInstance } from "axios";
import { Pagination } from "../types/PaginiationResult";
import {
  UserNotification,
  NotificationCreateRequest,
  NotificationUpdateRequest,
  Notification,
} from "../types/Notification";

export default class NotificationMessageService {
  private _endpoint = "/NotificationMessage";
  private _client: AxiosInstance;

  constructor(client: AxiosInstance) {
    this._client = client;
  }

  async getUserNotifications(
    page: number = 1,
    index: number = 6
  ): Promise<Pagination<UserNotification>> {
    const response = await this._client.get<Pagination<UserNotification>>(
      `${this._endpoint}/my-notifications`,
      { params: { page, index } }
    );
    return response.data;
  }

  async getNotifications(
    page: number = 1,
    index: number = 10,
    sort?: string,
    filter?: string
  ): Promise<Pagination<Notification>> {
    const response = await this._client.get<Pagination<Notification>>(
      this._endpoint,
      { params: { page, index, sort, filter } }
    );
    return response.data;
  }

  async addNotification(request: NotificationCreateRequest): Promise<void> {
    return await this._client.post(this._endpoint, request);
  }

  async updateNotification(request: NotificationUpdateRequest): Promise<void> {
    return await this._client.put(this._endpoint, request);
  }

  async markAsRead(notificationIds: string[]): Promise<void> {
    return await this._client.post(
      `${this._endpoint}/mark-read`,
      notificationIds
    );
  }

  async deleteNotification(notificationId: string): Promise<void> {
    return await this._client.delete(`${this._endpoint}/${notificationId}`);
  }

  async getUnreadCount(): Promise<any> {
    return await this._client.get(`${this._endpoint}/unread-count`);
  }
}
